/**
 * Zoekknop: delegeert aan uf-mobile-search-overlay (capture daar wint al).
 * Deze file blijft als fallback als overlay om wat voor reden niet geladen is.
 */
(function () {
  function usesOverlaySearch() {
    return (
      window.matchMedia('(max-width: 991px)').matches ||
      document.documentElement.classList.contains('uf-header-middle-compact')
    );
  }

  function bindTrigger() {
    // Overlay heeft eigen document-capture handler
    if (window.ufMobileSearchOverlayReady) return;

    if (typeof window.ufSetMobileSearchOpen !== 'function') {
      window.setTimeout(bindTrigger, 50);
      return;
    }

    var trigger = document.getElementById('searchlink');
    if (!trigger || trigger.dataset.ufSearchBound === '1') return;
    trigger.dataset.ufSearchBound = '1';

    trigger.addEventListener(
      'click',
      function (e) {
        if (!usesOverlaySearch()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var isOpen = document.body.classList.contains('uf-mobile-search-open');
        window.ufSetMobileSearchOpen(!isOpen);
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindTrigger);
  } else {
    bindTrigger();
  }
})();
